"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./sub-header.scss");
var SubHeader = function (_a) {
    var icon = _a.icon, subtitle = _a.subtitle;
    return (react_1.default.createElement("div", { className: "scr-nav-sub-heading-container" },
        react_1.default.createElement("div", { className: "scr-nav-sub-heading" },
            icon !== "" && (react_1.default.createElement("div", { className: "scr-visual-action-image" },
                react_1.default.createElement("img", { src: "".concat(icon), alt: "".concat(subtitle) }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("h3", { title: "".concat(subtitle) }, subtitle)))));
};
exports.default = SubHeader;
